import { Reducer } from 'redux';
import {
  GET_USER_PAGE_ERROR,
  GET_USER_PAGE_REQUEST,
  GET_USER_PAGE_RESPONSE,
  CLEAR_USER_PAGE} from '../actions/usersAction';
import { IPagedDataResponse, IUser, IApiRequest } from '../types';

const defaultData = { canLoadMore: false, data: [] } as IPagedDataResponse<IUser[]>;
const initialState: IApiRequest<IPagedDataResponse<IUser[]>>
  = { loading: true, data: defaultData, error: '', UpdatedAt: null };

const usersReducer: Reducer<IApiRequest<IPagedDataResponse<IUser[]>>>
= (state: IApiRequest<IPagedDataResponse<IUser[]>> = initialState, action : any) => {

  switch (action.type) {
    case GET_USER_PAGE_RESPONSE: {
      const data = state.data;

      if (action.loadMore) {
        data.data = data.data.concat(action.response.data);
      } else {
        data.data = action.response.data;
      }

      data.canLoadMore = action.response.canLoadMore;
      data.totalData = 0;

      return {
        data,
        UpdatedAt: null,
        loading: false,
        error: '',
      };
    }
    case CLEAR_USER_PAGE:
    case GET_USER_PAGE_REQUEST: {
      return {
        UpdatedAt: null,
        loading: action.type === GET_USER_PAGE_REQUEST,
        error: '',
        data: action.loadMore ? state.data : { canLoadMore: false, data: [] } as IPagedDataResponse<IUser[]>,
      };
    }
    case GET_USER_PAGE_ERROR: {
      return {
        UpdatedAt: null,
        loading: false,
        error: action.error || 'There was an error loading this product. Please try again.',
        data: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default usersReducer;
